import React, {useContext, useEffect} from 'react'
import {dataContext,localestr} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';

function CatCounterpartiesEdit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabClose=actions.tabClose

    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg

    const setValue=(name,data)=>{
        let newData={...wndData,changed:true}
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const update=(d)=>{
        //return
        let newData={...wndData,...d.data,changed:false}
        setWndData(newData)
        //tabClose()
    }
    
    const saveValue=(act)=>{
        let errmsg=''
        const name=(wndData.name || '').substring(0,50)
        const parent=wndData.parent || {id:null,name:null}
        const okpo=(wndData.okpo || '').substring(0,10)
        const address=(wndData.address || '').substring(0,100)
        const tell=(wndData.tell || '').substring(0,20)
        const note=(wndData.note || '').substring(0,85)

        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            let id=wndData.id
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:'CatCounterparties',data:{name,parent,okpo,address,tell,note}}
                saveData(newData,d=>{if(wndData.update) wndData.update(d.data);act(d)})
                //почекати ы закрити выкно
            }  
            else if(wndData.changed) {
                let newData={status:'mod',key:'CatCounterparties',data:{id,name,parent,okpo,address,tell,note}}
                saveData(newData,d=>{if(wndData.update) wndData.update(d.data);act(d)})
            }else if(act) act()     
        }

    }

    useEffect(() => {
        if (context.data['catCounterparties'] === undefined) {
            context.getData('catCounterparties')
        } 
    },)

    return(

    <div style={{display:'flex',flexDirection:'column', margin:'4px 0',alignSelf:'flex-start',flexGrow:'10000'}}>
    <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='20' width2='50' disabled={true}/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='50' width2='450'/>
    </div>
    <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={localestr('Телефон')} Value={wndData.tell} typeVal={'text'} setVal={(d)=>{setValue('tell',d)}} width1='64' width2='94'/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Код ЄДРПОУ')} Value={wndData.okpo} typeVal={'text'} setVal={(d)=>{setValue('okpo',d)}} width1='96' width2='90'/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Папка')} Value={wndData.parent} typeVal={'fldCounterparties'} setVal={(d)=>{setValue('parent',d)}} width1='44' width2='174' />
    </div>
    <EditCtrl Capt={localestr('Адреса')} Value={wndData.address} typeVal={'text'} setVal={(d)=>{setValue('address',d)}} width1='52' width2='526'/>
    <EditCtrl Capt={localestr('Примітка')} Value={wndData.note} typeVal={'text'} setVal={(d)=>{setValue('note',d)}} width1='68' width2='510'/>
    <div style={{margin:'10px 0 0 0',width:'337px',display:'flex',justifyContent:'center'}}>
    <div style={{width:'60px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue(tabClose)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    <div style={{width:'90px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue(update)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Зберегти')}</div></div>
    </div>
    </div>
    )
    
}

export default CatCounterpartiesEdit